import { create } from '../create-store/createStore';
import { Watchlist } from '../use-watchlist/watchlist-types';

export type EntitiesMapValue = Pick<Watchlist, 'id' | 'name'>[];

export type EntitiesMap = Record<string, EntitiesMapValue>;

export type WatchlistToCheck = Watchlist & {
  key: string;
  isChecked: boolean;
};

type State = {
  watchlistsToCheck: WatchlistToCheck[];
};

type Actions = {
  initialize: (lists: Watchlist[]) => void;
  toggleSelectAll: (prevIsChecked: boolean) => void;
  toggleSelectOne: (listId: string) => void;
};

type NewsWatchlistsStore = State & Actions;

export const useNewsWatchlistsStore = create<NewsWatchlistsStore>(
  (set, get) => ({
    watchlistsToCheck: [],
    initialize: (lists: Watchlist[]) => {
      if (lists) {
        const existedListMap = get().watchlistsToCheck.reduce<
          Record<string, boolean>
        >((accu, curr) => {
          return {
            ...accu,
            [curr.id]: curr.isChecked,
          };
        }, {});
        set({
          watchlistsToCheck: lists.map(list => {
            let isChecked = existedListMap[list.id];
            if (isChecked === undefined) {
              isChecked = false;
            }
            return { ...list, key: list.id, isChecked };
          }),
        });
      }
    },
    toggleSelectAll: (prevIsChecked: boolean) => {
      set({
        watchlistsToCheck: get().watchlistsToCheck.map(list => {
          return { ...list, isChecked: !prevIsChecked };
        }),
      });
    },
    toggleSelectOne: (listId: string) => {
      set({
        watchlistsToCheck: get().watchlistsToCheck.map(list => {
          if (list.id === listId) {
            return { ...list, isChecked: !list.isChecked };
          } else {
            return { ...list };
          }
        }),
      });
    },
  })
);
